import React, { useState, useEffect, useContext } from "react";
import { Parser } from 'html-to-react'
import Typography from "@mui/material/Typography";
import ModelContext from "../ModelContext";

export const LocalDoc = (props) => {
    const modelCtx = useContext(ModelContext);
    const [contentDoc, setContentDoc] = useState("");

    useEffect(() => {
        const getFile = async () => {
            const input = modelCtx.inputModelData;

            if (input.idBasicModel !== 0) {

                const response = await fetch("/api/model/localdoc/" + props.fileName, {
                    method: 'POST',
                    body: JSON.stringify(input),
                    headers: { 'Content-Type': 'application/json' }
                });

                if (response.ok) {
                    const data = await response.text(); // return a string
                    if (data) {
                        setContentDoc(data);
                    } else {
                        //props.feedbackCallback("error", "Errore durante la lettura delle informazioni sulla societ�", true);
                    }

                } else {
                    const error = await response.text();
                    console.log(error);
                    //props.feedbackCallback("error", error, true);
                }
            }
        }

        getFile();
    }, [modelCtx.inputModelData, props.fileName]);


   
    return (
        <Typography component="div" sx={{ flexGrow: 1, display: { xs: 'block', sm: 'block' } }}>
            {Parser().parse(contentDoc)}
        </Typography>
    );
};

export default LocalDoc;
